import actionTypes from './actionTypes'
import boardTypes from 'helpers/enums/canny/boardTypes'

const userActions = {
	getTooltips() {
		return {
			type: actionTypes.USER_GET_TOOLTIPS,
		}
	},

	saveTooltip(tooltipName) {
		return {
			type: actionTypes.USER_UPDATE_TOOLTIP,
			tooltipName,
		}
	},

	saveTooltipError(serverError) {
		return {
			type: actionTypes.USER_UPDATE_TOOLTIP_ERROR,
			serverError,
		}
	},

	getUserData() {
		return {
			type: actionTypes.USER_GET_DATA,
		}
	},

	sendHelp(text, title) {
		return {
			type: actionTypes.HELPBOX_SEND_HELP,
			text,
			title,
		}
	},

	userComplementaryDataFetched(response) {
		return {
			type: actionTypes.USER_COMPLEMENTARY_DATA_FETCHED,
			data: response.payload,
		}
	},

	userDisplayUpgradeMessage(upgrade_data) {
		return {
			type: actionTypes.USER_UPGRADE_MESSAGE,
			upgrade_data,
		}
	},

	userUpgradeActionSelected(upgrade_data, button_data) {
		return {
			type: actionTypes.USER_UPGRADE_ACTION_SELECTED,
			upgrade_data,
			button_data,
		}
	},

	getFeatureFlagsSuccess(featureFlags) {
		return {
			type: actionTypes.FEATURE_FLAGS_GET_SUCCESS,
			featureFlags,
		}
	},

	userDataFetched(payload, fullData) {
		return {
			type: actionTypes.USER_DATA_FETCHED,
			payload,
			fullData,
		}
	},

	initializeTooltip: tooltipType => ({
		type: actionTypes.USER_TOOLTIP_INITIALIZE,
		tooltipType,
	}),

	identifyUserSuccess() {
		return {
			type: actionTypes.USER_IDENTIFY_SUCCESS,
		}
	},

	identifyCannyUserSuccess(boardType) {
		return {
			type: actionTypes.USER_CANNY_IDENTIFY_SUCCESS,
			boardType,
		}
	},

	identifyCannyUserError(serverError) {
		return {
			type: actionTypes.USER_CANNY_IDENTIFY_ERROR,
			serverError,
		}
	},

	suggestionsButtonSelected() {
		return {
			type: actionTypes.USER_SEND_SUGGESTIONS_BUTTON_SELECTED,
			boardType: boardTypes.PRODUCT_FEEDBACK,
		}
	},

	acceptTermsAndConditions() {
		return {
			type: actionTypes.USER_ACCEPT_TERMS_AND_CONDITIONS,
		}
	},

	acceptTermsAndConditionsError() {
		return {
			type: actionTypes.USER_ACCEPT_TERMS_AND_CONDITIONS_ERROR,
		}
	},

	acceptTermsAndConditionsSuccess() {
		return {
			type: actionTypes.USER_ACCEPT_TERMS_AND_CONDITIONS_SUCCESS,
		}
	},

	getPermissionsSuccess(payload) {
		return {
			type: actionTypes.USER_PERMISSIONS_FETCH_SUCCESS,
			payload,
		}
	},

	getPermissionsFailed() {
		return {
			type: actionTypes.USER_PERMISSIONS_FETCH_FAILED,
		}
	},
}

export default userActions
